import { ProductMetafields, ShopSettings } from "~/types"
import DescriptionTab from "./DescriptionInTabs.client";
import useSettingsShop from "~/rs-components/shop/useShopSettings";
import { useSetupDescription } from "../../../../setup/settings/__product";
import { SetupDescriptionProduct } from "../../../../setup/components/setup/productDetail/SetupDescriptionProduct.client";

type ProductDescriptionProps = 
{
    product: ProductMetafields,
    shopSettings: ShopSettings
}

export default function ProductDescription({ product, shopSettings }: ProductDescriptionProps) 
{
    return (
        <div className="overview sm:px-0 lg:my-5">
            <div className="description-container">
                {returnDescription(product, shopSettings)}
            </div>
        </div>
    )
}

const returnDescription = (product: ProductMetafields, shopSettings:ShopSettings) =>
{
    const { enableProductDetailsTab } = useSettingsShop(shopSettings);
    if(useSetupDescription) return <SetupDescriptionProduct product={product}></SetupDescriptionProduct>;
    else if(enableProductDetailsTab) return <DescriptionTab product={product}></DescriptionTab>;
    else return <p dangerouslySetInnerHTML={{ __html: product.descriptionHtml }}></p> ;
}


const comments = () => 
{
    const comment = "I found this commented code and I didn't want to delete it, I separated it. Michael";
    return (
        {/* 
            <div className="features-container mb-10">
                <h3>Features</h3>
                <div className="customizable">
                    <div className="icon">
                        <CustomizeIcon />
                    </div>
                    <div className="description">
                        <p><span>Customizable</span>Lorem Ipsum es simplemente el texto de relleno de las imprentas y archivos de texto. </p>
                    </div>
                </div>
                <div className="assemble">
                    <div className="icon">
                        <AssembleIcon />
                    </div>
                    <div className="description">
                        <p>
                            <span>
                                Assemble
                            </span>
                            Lorem Ipsum es simplemente el texto de relleno de las imprentas y archivos de texto. 
                        </p>
                    </div>
                </div>
            </div> 
        */}
    )
}